import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslator, localeSelector } from '@gandi/translate';
import { createLogger } from 'gandi.redux-logger';
import { useNotifications } from '../../../hooks/notifications';
import { pay, setPaymentCallParams } from '../../../modules/money';
import { submitMyCardCreation } from '../../../modules/mycards';
import { refillPrepaid } from '../../../modules/refillprepaid';
const logger = createLogger('@gandi/billing newPaymentForm');
const extractPaymentProductId = ({
  key
}) => {
  const idAttempt = Number(key.slice(2));
  return Number.isNaN(idAttempt) ? undefined : idAttempt;
};
export function usePaymentProvider(context, order, returnUrl, sharingId, amount, currency) {
  const dispatch = useDispatch();
  const {
    __
  } = useTranslator();
  const locale = useSelector(localeSelector);
  const {
    notifyMaybeApiError
  } = useNotifications();
  const [isGandiPaying, setIsGandiPaying] = React.useState(false);
  const getProviderCallParams = React.useCallback(async (selectedMethod, saveMethod) => {
    if (!selectedMethod) {
      return;
    }
    try {
      if (['pay', 'flush', 'recurrent'].includes(context) && order) {
        setIsGandiPaying(true);
        if (saveMethod && selectedMethod.code !== 'mycard' && selectedMethod.allow_recurrent) {
          const paymentProductId = extractPaymentProductId(selectedMethod);
          setIsGandiPaying(true);
          await dispatch(submitMyCardCreation({
            provider: selectedMethod.provider,
            paymentProductId
          }, {
            orderId: order.id,
            amount,
            currency,
            redirectTo: returnUrl,
            sharingId
          }));
        } else {
          const {
            data
          } = await dispatch(pay({
            provider: selectedMethod.provider,
            code: selectedMethod.code,
            key: selectedMethod.key,
            orderId: order.id,
            amount,
            currency,
            returnUrl,
            locale,
            payUrl: selectedMethod.pay_url
          }, {
            sharingId
          }));
          dispatch(setPaymentCallParams(data));
        }
      }
      if (context === 'refill' && amount) {
        setIsGandiPaying(true);
        await dispatch(refillPrepaid({
          paymentType: `${selectedMethod.provider}-${selectedMethod.code}-${selectedMethod.key}`,
          amount,
          orderId: order?.id,
          returnUrl,
          payUrl: selectedMethod.pay_url,
          saveUrl: selectedMethod.save_url
        }, {
          sharingId,
          savePaymentMethod: saveMethod
        }));
      }
    } catch (err) {
      dispatch(logger.error({
        err
      }, 'Unable to process payment'));
      dispatch(notifyMaybeApiError(err, __('Unable to process payment. Please try again using a different payment method.')));
    } finally {
      setIsGandiPaying(false);
    }
  }, [__, amount, context, currency, dispatch, locale, notifyMaybeApiError, order, returnUrl, sharingId]);
  return {
    getProviderCallParams,
    isGandiPaying
  };
}